import { oauthApi } from "@/features/oauth";
import { HStack, Icon } from "@/shared/ui/primitives";
import { buildGoogleOAuthUrl } from "../login.utils";

type OAuthButtonsProps = {
	kakaoOAuthUrl: string;
};

export const OAuthButtons = ({ kakaoOAuthUrl }: OAuthButtonsProps) => {
	const navigateToOAuth = (url: string) => {
		window.location.href = `${url}?t=${Date.now()}`;
	};

	return (
		<HStack className="gap-[20px]">
			<button
				type="button"
				className="p-[12px] rounded-[24px] bg-[#03C75A]"
				onClick={() => navigateToOAuth(oauthApi.getProviderUrl("NAVER"))}
			>
				<Icon name="Naver" width={20} height={20} colors={["#FFFFFF"]} />
			</button>
			<button
				type="button"
				className="p-[12px] rounded-[24px] bg-[#FEE500]"
				onClick={() => navigateToOAuth(kakaoOAuthUrl)}
			>
				<Icon name="Kakao" width={20} height={20} colors={["#000000", "#000000"]} />
			</button>
			<button
				type="button"
				className="p-[12px] rounded-[24px] bg-[#FFFFFF] outline-outline"
				onClick={() => {
					window.location.href = buildGoogleOAuthUrl(import.meta.env.VITE_API_URL, Date.now());
				}}
			>
				<Icon
					name="Google"
					width={20}
					height={20}
					colors={["#FFC107", "#FF3D00", "#4CAF50", "#1976D2"]}
				/>
			</button>
		</HStack>
	);
};
